import * as React from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { styled } from "@mui/system";

const StyledSwitch = styled(Switch)(({ theme, checked }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    opacity: 0.12,
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
    transform: checked ? "translateX(0px)" : "translateX(0px)",
  },
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: "var(--dmg-blue-accent)",
    opacity: 0.9,
  },
  "& .MuiSwitch-colorPrimary.Mui-checked + .MuiSwitch-track": {
    backgroundColor: "var(--dmg-blue-accent)",
    opacity: 0.2,
  },
  "& .MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track": {
    opacity: 0.9,
    backgroundColor: "var(--dmg-gray-300)",
  },
  ".MuiFormControlLabel-root": {
    marginRight: 0,
  },
}));

interface CustomizedSwitch {
  label?: string;
  name?: string;
  checked: boolean;
  disabled?: boolean;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

export default function CustomizedSwitch(props: CustomizedSwitch) {
  const { label, name, checked, disabled, onChange } = props;
  return (
    <FormControlLabel
      style={{
        color: "var(--dmg-blue-accent)",
        fontSize: "20px",
        marginRight: "8px",
      }}
      control={
        <StyledSwitch
          name={name}
          defaultChecked={checked}
          disabled={disabled}
          onChange={onChange}
          checked={checked}
        />
      }
      label={label}
    />
  );
}
